<template>
  <div class="home-page">
    <nav class="nav-container">
      <headers></headers>

      <div class="nav-tabs">
        <div class="Logo-container">
          <div class="Logo">
            <div>
              <img style="width: 40px;" :src="navItems[0].link" alt="">
            </div>
            <div>
              {{ navItems[0].name }}
            </div>
          </div>
        </div>
        <div class="nav-items-group">
          <div @mouseover="dropDownChange(item)" v-for="item in navItems" :key="item.name" v-show="item.name !== '遵农共享'">
            <div @click="Active(item)" class="nav-item" :class="{ 'active': activeNav === item.name }"
              v-if="item.name === 'sustainableDevelopment' || item.name === 'home'">
              {{ $t(`navItems.${item.name}`) }}
            </div>
            <el-dropdown @command="handleCommand" v-else trigger="hover" class="nav-item"
              :class="{ 'active': activeNav === item.name }">
              <div>
                {{ $t(`navItems.${item.name}`) }}
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="subItem" class="dropdown-item" v-for="subItem in downList"
                  :key="subItem.label">{{ $t(`downlist.${subItem.label}`)
                  }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </nav>
    <!-- 轮播图 -->
    <section ref="navContainer"  class="content-container">
      <el-carousel autoplay height="750px">
        <el-carousel-item v-for="item in banner" :key="item.imgUrl">
          <img :src="item.imgUrl" alt="" style="object-fit: fill;width: 100%;height: 100%;">
          <div class="text-stroke"
            style="position: absolute;bottom: 10%;left: 10%;font-size: 2em;z-index: 1;color: #fff;font-weight: bold;">
            {{ $t(`bannerItems.${item.title}`) }}</div>
        </el-carousel-item>
      </el-carousel>
    </section>
    <!-- 展示区 -->
    <section class="content-container" style="margin: 8em auto;">
      <div class="main-layout">
        <div class="banner-wrapper" style="overflow: hidden;">
          <img @mouseover="mouseOver(null)" @mouseout="mouseOut(null)" ref="bannerImg" class="banner-img"
            src="../images/banner.jpeg" alt="">
        </div>
        <div class="img-container">
          <div style="overflow: hidden;" v-for="(item, index) in imglist" :key="index">
            <img ref="gridImg" @mouseover="mouseOver(index)" @mouseout="mouseOut(index)" class="grid-img" :src="item"
              alt="">
          </div>
        </div>
      </div>
    </section>
    <!-- 项目 -->
    <section class="content-container" style="margin-top: 8em;">
      <div class="project-container">
        <div v-for="(item, index) in projectlist" :key="index" class="project-item">
          <div>
            <div class="project-value">{{ item.value }}</div>
            <div class="project-name">{{ $t(`projectlist.${item.name}`) }}</div>
          </div>
        </div>
      </div>
      <div class="project">
        <div class="project-title" style="font-size: 4.2em;">
          {{ $t(`projectlist.title1`) }}
        </div>
      </div>
    </section>
    <div style="width: 100%;height: 22em;margin-top: 3em;">
      <img src="../images/Banner.png" style="width: 100%;height: 100%;" alt="">
    </div>
    <section class="content-container" style="margin-top: 1em;">
      <div style="line-height: 3;font-size: 1.2em;">
        <div style="text-align: center;">
          {{ $t(`projectlist.projectContent`) }}
        </div>
        <div style="text-align: center;font-weight: bold;">
          {{ $t(`projectlist.projectTitle`) }}
        </div>
      </div>
      <div>
        <el-carousel autoplay height="650px">
          <el-carousel-item v-for="item in projectcarousel" :key="item.imgUrl">
            <img :src="item.imgUrl" alt="" style="object-fit: contain;text-align: center; width: 100%;height: 100%;">
          </el-carousel-item>
        </el-carousel>
        <div style="display: flex;justify-content: space-between;margin-top: 2em;">
          <img v-for="item in projectcarousel" :key="item.imgUrl" :src="item.imgUrl"
            style="width: 100px;height: 100px;object-fit: contain;" alt="">
        </div>
      </div>
    </section>
    <!-- 新闻中心 -->
    <section class="content-container" style="font-family: 'Courier New', Courier, monospace;">
      <div class="project-title" style="font-size: 4.2em;">
        {{ $t(`news.title`) }}
      </div>
      <div style="display: flex;align-items: center; width: 100%;">
        <div style="font-size: 1.8em;font-weight: bold; white-space: nowrap;">
          遵农共享新闻动态:
        </div>
        <div class="news-scroll-container" @mouseover="stopScroll" @mouseout="startScroll">
          <div ref="newsWrapper" class="news-wrapper">
            <div v-for="(item, index) in newsList" :key="index" class="news-item">
              {{ $t(`news.${item.items}`) }}
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex;gap: 2em;margin-top: 2em;">
        <div style="width: 25%;display: flex;flex-direction: column;align-items: center;border: 1px solid #ddd;"
          v-for="(item, index) in newsContent" :key="index">
          <div style="height: 20em;">
            <img :src="item.imgUrl" alt="" style="width: 100%;height: 100%;object-fit: fill;">
          </div>
          <div style="font-size: 0.8em;padding: 0.5em;">
            {{ $t(`news.${item.content}`) }}
          </div>
        </div>
      </div>
    </section>
    <!-- 加入我们 -->
    <section ref="joinUs" class="content-container" style="margin-top: 2em;">
      <div class="project-title" style="font-size: 4.2em;">
        <div>
          {{ $t(`ContactUs.title`) }}
        </div>
      </div>
      <div
        style="display: flex;justify-content: center;text-align: center;align-items: center;gap: 2em;margin-top: 2em;">
        <div>
          <div>
            {{ $t(`ContactUs.content1`) }}
          </div>
          <div>
            {{ $t(`ContactUs.content2`) }}
          </div>
          <div @click="toJob" style="color: #46B135;cursor: pointer;font-weight: bold;">
            {{ $t(`ContactUs.content3`) }}
          </div>
        </div>
        <div style="text-align: left;">
          <div>
            {{ $t(`ContactUs.content4`) }}
          </div>
          <div>
            {{ $t(`ContactUs.content5`) }}
          </div>
          <div>
            {{ $t(`ContactUs.content6`) }}
          </div>
          <div>
            {{ $t(`ContactUs.content7`) }}
          </div>
          <div>
            {{ $t(`ContactUs.content8`) }}
          </div>
          <div>
            {{ $t(`ContactUs.content9`) }}
          </div>
        </div>
        <div>
          <img style="width: 100px;height: 100px;" src="../images/apps.png" alt="">
        </div>
      </div>

    </section>
  </div>
</template>

<script>
import logo from '../images/nyj-logo.jpg';
import headers from '@/components/header/headers';
import banner from '../images/banner.jpeg';
import banner2 from '../images/banner2.png';
import banner3 from '../images/banner3.png';
import banner4 from '../images/banner4.png';
import banner5 from '../images/banner5.png';
import banner6 from '../images/banner6.png';
import banner7 from '../images/banner7.png';
import banner8 from '../images/banner8.png';
import tianfangyuan from '../images/tianfangyuan.jpg';
import yaluanwan from '../images/yaluanwan.jpg';
import chengcaiyuncang from '../images/chengcaiyuncang.jpg';
import geren from '../images/geren_LOGO.png';
import shengxianLOGO from '../images/shengxian_LOGO.png';
import news1 from '../images/news1.png';
import news2 from '../images/news2.png';
import news3 from '../images/news3.png';
import news4 from '../images/news4.png';

export default {
  name: "HomePage",
  components: { headers },
  data() {
    return {
      components: { headers },

      newsContent: [{
        content: 'items1', imgUrl: news1
      },
      {
        content: 'items2', imgUrl: news2
      },
      {
        content: 'items3', imgUrl: news3
      },
      {
        content: 'items4', imgUrl: news4
      },
      ],
      // 原始新闻数据
      news: [
        { items: 'items1' },
        { items: 'items2' },
        { items: 'items3' },
        { items: 'items4' },
      ],
      newsList: [], // 用于滚动的列表
      projectcarousel: [
        { imgUrl: tianfangyuan },
        { imgUrl: yaluanwan },
        { imgUrl: chengcaiyuncang },
        { imgUrl: geren },
        { imgUrl: shengxianLOGO },
        { imgUrl: logo }
      ],
      projectlist: [
        { name: 'name1', value: '1000+' },
        { name: 'name2', value: '30+' },
        { name: 'name3', value: '10+' },
        { name: 'name4', value: '10+' }
      ],
      imglist: [banner3, banner4, banner5, banner6, banner7, banner8],
      downList: [],
      banner: [
        { imgUrl: banner2, title: 'bannerContent2' },
        { imgUrl: banner3, title: 'bannerContent3' },
        { imgUrl: banner4, title: 'bannerContent4' }
      ],
      navItems: [
        { name: "遵农共享", link: logo },
        { name: 'home' },
        { name: "aboutUs" },
        { name: "products" },
        { name: "sustainableDevelopment" },
        { name: "joinUs" }
      ],
      activeNav: 'home',
      scrollTimer: null,
      currentIndex: 0,
      itemHeight: 31, // 与新闻行高一致
      scroll: '',
    };
  },
  created() {
    // 从URL获取scroll参数
    this.scroll = this.$route.query.scroll;
    if (this.scroll==='label11') {
      this.$nextTick(() => {
        this.$refs.joinUs.scrollIntoView({ behavior: 'smooth' });
      });
    }else if (this.scroll==='label10') {
      this.$nextTick(() => {
        this.$refs.joinUs.scrollIntoView({ behavior: 'smooth' });
      });
    }
    // 提前处理新闻列表（避免mounted中DOM未渲染）
    this.newsList = [...this.news, this.news[0]]; // 复制第一条到末尾
  },
  mounted() {
    // 确保DOM渲染完成后再启动滚动
    this.$nextTick(() => {
      this.startScroll();
    });
  },
  beforeDestroy() {
    this.stopScroll();
  },
  methods: {
    getLoopDataSource(item) {
      // 多选类型：按选中的选项数量循环
      if (item.type === 'multi_select' || item.type === 'multi_value_measure') {
        return Array.isArray(item.VmodelName) ? item.VmodelName.map((_, idx) => ({ id: idx })) : [{ id: 0 }];
      }
      // 其他类型：循环1次
      return [{ id: 0 }];
    },
    handleCommand(item) {
      console.log(item);
      if (item.label === 'label1') {
        this.$router.push({ path: 'about', query: { active: 'label1' } });
      } else if (item.label === 'label2') {
        this.$router.push({ path: 'about', query: { active: 'label2' } });
      } else if (item.label === 'label3') {
        this.$router.push({ path: 'about', query: { active: 'label3' } });
      } else if (item.label === 'label4') {
        this.$router.push({ path: 'project', query: { active: 'label4' } });
      } else if (item.label === 'label5') {
        this.$router.push({ path: 'project', query: { active: 'label5' } });
      } else if (item.label === 'label6') {
        this.$router.push({ path: 'project', query: { active: 'label6' } });
      } else if (item.label === 'label7') {
        this.$router.push({ path: 'project', query: { active: 'label7' } });
      } else if (item.label === 'label8') {
        this.$router.push({ path: 'project', query: { active: 'label8' } });
      } else if (item.label === 'label9') {
        this.$router.push({ path: 'project', query: { active: 'label9' } });
      } else if (item.label === 'label10') {
          this.$refs.joinUs.scrollIntoView({ behavior: 'smooth' });
      }else if (item.label === 'label11') {
         this.$refs.joinUs.scrollIntoView({ behavior: 'smooth' });

      }
    },
    toJob() {
      window.open('https://mp.weixin.qq.com/s/fQfDxZILdrZACvmTRXawmA', '_blank');
    },
    // 启动滚动
    startScroll() {
      this.stopScroll(); // 清除旧定时器

      this.scrollTimer = setInterval(() => {
        this.currentIndex++;
        const newsWrapper = this.$refs.newsWrapper;

        // 确保元素存在再操作
        if (!newsWrapper) return;

        // 正常滚动
        newsWrapper.style.transition = 'transform 1s ease-in-out';
        newsWrapper.style.transform = `translateY(-${this.currentIndex * this.itemHeight}px)`;

        // 当滚动到复制的最后一条时
        if (this.currentIndex === this.news.length) {
          // 等过渡结束后，无缝重置
          setTimeout(() => {
            newsWrapper.style.transition = 'none'; // 取消过渡
            this.currentIndex = 0;
            newsWrapper.style.transform = 'translateY(0)'; // 瞬间回到顶部
          }, 1000); // 与过渡时间一致（1秒）
        }
      }, 3000); // 3秒滚动一次（可调整速度）
    },
    // 停止滚动
    stopScroll() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer);
        this.scrollTimer = null;
      }
    },
    // 图片hover缩放
    mouseOver(index) {
      try {
        if (index === 0 || index) {
          this.$refs.gridImg[index].style.transform = 'scale(1.1)';
        } else {
          this.$refs.bannerImg.style.transform = 'scale(1.1)';
        }
      } catch (e) { /* 忽略refs未加载的情况 */ }
    },
    mouseOut(index) {
      try {
        if (index === 0 || index) {
          this.$refs.gridImg[index].style.transform = 'scale(1)';
        } else {
          this.$refs.bannerImg.style.transform = 'scale(1)';
        }
      } catch (e) { /* 忽略refs未加载的情况 */ }
    },
    // 下拉菜单切换
    dropDownChange(item) {
      this.downList = [];
      if (item.name === 'aboutUs') {
        this.downList = [{ label: 'label1' }, { label: 'label2' }, { label: 'label3' }];
      } else if (item.name === 'products') {
        this.downList = [{ label: 'label4' }, { label: 'label5' }, { label: 'label6' }, { label: 'label7' }, { label: 'label8' }, { label: 'label9' }];
      } else if (item.name === 'joinUs') {
        this.downList = [{ label: 'label10' }, { label: 'label11' }];
      }
    },
    // 导航激活
    Active(item) {
      console.log(item);
      this.activeNav = item.name;
      if (item.name === 'sustainableDevelopment') {
        this.$router.push({ path: 'development', query: { active: 'development' } });
      }
       if (item.name === 'home') {
        this.$router.push({ path: '/HomePage'});
        this.$refs.navContainer.scrollIntoView({ behavior: 'smooth' });
        console.log(this.$refs.navContainer);
      }
    }
  }
};
</script>

<style scoped>
.dropdown-item:hover {
  color: #46B135;
  background-color: rgba(70, 177, 53, 0.1);
}

/* 新闻滚动核心样式 */
.news-scroll-container {
  height: 31px;
  overflow: hidden;
  margin-left: 1em;
  position: relative;
  flex: 1;
  /* 占满剩余宽度 */
}

.news-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.news-item {
  height: 31px;
  line-height: 31px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  font-size: 1.7em;
}

/* 原有样式保持不变 */
.project-title {
  margin-top: 3em;
  text-align: center;
  color: var(--glwColor);
  font-size: 3em;
  font-family: 'Courier New', Courier, monospace;
}

.project-value {
  font-size: 2.5em;
}

.project-name {
  font-size: 1.5em;
  font-family: 'Courier New', Courier, monospace;
}

.project-item {
  min-width: 20em;
  text-align: center;
}

.project-container {
  display: flex;
  justify-content: center;
  gap: 2em;
}

.main-layout {
  display: flex;
  gap: 2em;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  /* 响应式换行 */
}

.banner-wrapper {
  margin: 1em 0;
}

.banner-img {
  width: 22em;
  height: 32em;
  object-fit: cover;
  transition: transform 0.5s;
}

.img-container {
  display: grid;
  grid-template-columns: repeat(3, 21em);
  grid-template-rows: repeat(2, 15.6em);
  gap: 1em;
  align-content: flex-start;
}

@media screen and (max-width: 1200px) {
  .img-container {
    grid-template-columns: repeat(2, 21em);
  }
}

@media screen and (max-width: 768px) {
  .img-container {
    grid-template-columns: 1fr;
  }

  .banner-img {
    width: 100%;
    height: auto;
  }
}

.grid-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s;
}

.text-stroke {
  text-shadow: 0 -6px 4px var(--glwColor),
    4px -4px 4px var(--glwColor),
    6px 0 4px var(--glwColor),
    4px 4px 4px var(--glwColor),
    0 6px 4px var(--glwColor),
    -4px 4px 4px var(--glwColor),
    -6px 0 4px var(--glwColor),
    -4px -4px 4px var(--glwColor);
}

.content-container {
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 1em;
  box-sizing: border-box;
}

.nav-container {
  position: sticky;
  top: 0;
  width: 100%;
  box-shadow: 0 2px 4px rgba(var(--glwColorRgb), 0.1);
  padding: 0 1em;
  background: #fff;
  z-index: 999;
  box-sizing: border-box;
}

.Logo {
  display: flex;
  align-items: center;
  gap: 0.5em;
  font-weight: bold;
}

.nav-tabs {
  margin: 0 auto;
  width: 100%;
  max-width: 1500px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2em;
  cursor: pointer;
}

.nav-items-group {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2em;
  flex: 1;
}

.nav-item {
  text-align: center;
  min-width: 5em;
  font-size: 1em;
  position: relative;
  display: inline-block;
  padding: 0.8em 0;
  line-height: 1.2;
  box-sizing: border-box;
  transition: color 0.3s ease;
}

.nav-item:hover::after,
.nav-item.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: var(--glwColor);
  transition: width 0.3s ease;
}

.nav-item:hover,
.nav-item.active {
  color: var(--glwColor);
}

.home-page {
  --glwColor: #46B135;
  --glwColorRgb: 70, 177, 53;
  font-size: 16px;
}

@media screen and (max-width: 1500px) {
  .home-page {
    font-size: 16px;
  }
}

@media screen and (max-width: 1200px) {
  .home-page {
    font-size: 14px;
  }
}

@media screen and (max-width: 768px) {
  .home-page {
    font-size: 10px;
  }

  .nav-items-group {
    gap: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue